// extracted by mini-css-extract-plugin
export default {"bg":"k1u4SU","inlineContent":"LvPOp8","pageWrapper":"q9zLBo","root":"vEynEu"};